import {
  AddFolderResponse,
  DeleteResponse,
  FolderResponse,
  MoveResponse,
} from '@/types/folders/folder';
import { httpServices } from '../axiosClient';
import {
  mockGetFolder,
  mockCreateFolder,
  mockDeleteFolder,
  mockRenameFolder,
  mockEditFolderTags,
  mockMoveFolder,
} from '../mock/documents/services/mockFolderService';

const USE_MOCK = import.meta.env.VITE_USE_MOCK_DB === 'true';

export const getFolder = async (data: any) => {
  const response = await httpServices.llmService.get<FolderResponse>(
    '/folder',
    data,
  );
  return response;
};

export const getFolderDescendants = async (
  folderId: string,
): Promise<{
  success: boolean;
  data: { folder_ids: string[]; file_ids: string[] };
}> => {
  const response = await httpServices.llmService.post<any>(
    '/folder/descendants',
    { folder_id: folderId },
  );
  return response;
};

export interface FolderDescendantsBatchResponse {
  success: boolean;
  data?: {
    descendants?: Record<string, { folder_ids: string[]; file_ids: string[] }>;
  };
  error?: string;
}

/**
 * Resolve the descendants of several folders in one request, which lets a
 * caller derive the selection state of a whole folder listing without a
 * request per folder.
 */
export const getFolderDescendantsBatch = async (
  folderIds: string[],
): Promise<FolderDescendantsBatchResponse> => {
  return await httpServices.llmService.post<FolderDescendantsBatchResponse>(
    '/folder/descendants',
    { folder_ids: folderIds },
  );
};

export const createFolder = async (data: any): Promise<AddFolderResponse> => {
  return await httpServices.llmService.post<AddFolderResponse>(
    '/folder',
    {},
    data,
  );
};

export const deleteFolder = async (data: any) => {
  if (USE_MOCK) {
    return mockDeleteFolder(data);
  }
  const response = await httpServices.llmService.delete<DeleteResponse>(
    `/folder`,
    data,
  );
  return response;
};

export const renameFolder = async (params: any) => {
  if (USE_MOCK) {
    return mockRenameFolder(params);
  }
  const response = await httpServices.llmService.post<any>(
    `/folder/rename`,
    {},
    params,
  );
  return response;
};

export const editFolderTags = async (folder_id: string, data: any) => {
  if (USE_MOCK) {
    return mockEditFolderTags(folder_id, data);
  }
  const response = await httpServices.llmService.post(
    `/folder/${folder_id}/tags`,
    data,
  );
  return response;
};

export const moveFolder = async (data: any) => {
  if (USE_MOCK) {
    return mockMoveFolder(data);
  }
  const response = await httpServices.llmService.post<MoveResponse>(
    `/folder/move`,
    {},
    data,
  );
  return response;
};
